import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_19: FaireProductEntity = {
  token: "catalog_prod_prod-19",
  type: "product",
  name: "Cake Stand - Ceramic Swirl - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 77.91,
  msrpDollars: 194.77,
  sku: "CO0019",
  caseSize: 3,
  material: "Ceramic",
  collectionToken: "col_confetti-cake",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 255,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["cat_household-all"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
